<template>
    <div class="login-page">
        <div class="login-box">
            <div class="card card-outline card-primary">
                <div class="card-header text-center">
                    <a href="#" class="h2">SendAll</a>
                </div>
                <div class="card-body">
                    <p class="text-center text-bold text-gray">Novo Cadastro</p>
                    <div class="form-group">
                        <input type="text" name="name" :class="{ 'is-invalid': errors.has('name') }"
                            v-model="request.name" class="form-control" v-bind:placeholder="$t('attributes.name')"
                            v-validate="'required'" @keyup="clearSignInError()">
                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('name')}}</div>
                    </div>
                    <div class="form-group">
                        <input type="text" name="document" :class="{ 'is-invalid': errors.has('document') }"
                            v-model="request.document" class="form-control" v-bind:placeholder="'CPF'"
                            v-validate="{required: true,  document:true}" v-mask="'###.###.###-##'">
                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('document')}}</div>
                    </div>
                    <div class="form-group">
                        <input type="text" name="phone" :class="{ 'is-invalid': errors.has('phone') }"
                            v-model="request.phone" class="form-control" v-bind:placeholder="'Celular'"
                            v-validate="{required: true}"  v-mask="['(##)####-####', '(##)#####-####']">
                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('phone')}}</div>
                    </div>
                    <div class="form-group">
                        <input type="text" name="email" :class="{ 'is-invalid': errors.has('email') }"
                            v-model="request.email" class="form-control" v-bind:placeholder="$t('attributes.email')"
                            v-validate="'required|email'" @keyup="clearSignInError()">
                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
                    </div>
                    <div class="form-group">
                        <input type="password" name="password" :class="{ 'is-invalid': errors.has('password') }"
                            v-model="request.password" class="form-control"
                            v-bind:placeholder="$t('attributes.password')" v-validate="'required|min:4'"
                            @keyup="clearSignInError()">
                        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('password')}}</div>
                    </div>
                    <div class="row mx-0 align-items-center justify-content-around">
                        <div class="col-md-4">
                            <router-link :to="{ name: 'login' }">Voltar</router-link>
                        </div>
                        <div class="col-md-8 px-0">
                            <button type="button" @click="signUp()" :disabled="loading" class="btn btn-primary w-100">
                                <span class="px-2">Cadastrar</span> <i v-show="loading"
                                    class="fa fa-circle-o-notch fa-spin"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';
    export default {
        data() {
            return {
                request: {
                    name: null,
                    email: '',
                    document: null,
                    phone: null,
                    password: null,
                    companyId: null,
                    grecaptcha: null
                },
                loading: false,
                error: '',
                success: '',
                loginMsg: '',
                companies: [],
            }
        },
        beforeMount() {
            setTimeout(() => {
                this.cookies = Cookies.get('politica')
            }, 1500);
        },
        methods: {
            setCookie() {
                this.cookies = true;
                Cookies.set('politica', this.cookies, {
                    expires: 365
                })
                this.$forceUpdate()
            },
            resetMsg() {
                this.message = '';
                this.error = '';
            },
            signUp() {
                this.request.email = this.request.email.replace(/\s/g, '');
                this.$validator.validateAll().then(async valid => {
                    if (!valid) {
                        return;
                    }
                    this.request.grecaptcha = await this.$recaptcha("signUpWhats").then(token => {
                        return token;
                    });
                    this.loading = true;
                    this.$auth.signUp(this.request)
                        .then(response => {
                            toastr({
                                icon: response.status,
                                title: response.message
                            });
                            this.$auth.login(this.request).then(r => {
                                if (r.data.access_token) {
                                    window.location.href = "/dashboard";
                                }
                            });
                        }).catch(error => {
                            if (error.two_factory) {
                                this.showTwoFactoryModal(error);
                                return;
                            }
                            if (typeof error.message != 'undefined') {
                                toastr({
                                    icon: error.status,
                                    title: error.message
                                });
                            }
                        }).finally(fn => {
                            this.loading = false;
                        })
                });
            },
            clearSignInError() {
                this.signin_error = null;
            },
            showTwoFactoryModal(error) {
                error.data.two_factory == 'E' ?
                    this.$refs.mTwoFactoryEmail.show(error) : this.$refs.mTwoFactoryGoogle.show(error);
            }
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap.min.css"></style>
<style scoped>
    #app .container {
        max-width: 100%;
    }

    #first {
        height: 100vh;
        background-color: darkgray !important;
    }

    img {
        width: 100%;
        height: 100%;

        position: fixed;
        left: 0;
        z-index: -999;
    }

    /* ----- SECTION-LOGIN ----- */
    #section-login {
        width: 100%;
        height: 100vh;
        position: absolute;
        right: 3vh;
    }


    .router-anim-home-enter-active {
        animation: home 0.6s;
    }

    .router-anim-home-leave-active {
        animation: home 0.6s;
        animation-direction: reverse;
    }

    @keyframes home {
        from {
            transform: translateX(30vw);
        }

        to {
            transform: translateX(0);
        }
    }

    .router-anim-bg-enter-active {
        animation: coming-bg 0.6s;
        animation-duration: 1s;
    }

    .router-anim-bg-leave-active {
        animation: going-bg 0.6s;
        animation-duration: 1s;
    }

    @keyframes coming-bg {
        from {
            transform: translateX(100vw);
        }

        to {
            transform: translateX(0);
        }
    }

    @keyframes going-bg {
        from {
            transform: translateX(0);
        }

        to {
            transform: translateX(-100vw);
        }
    }

    /* ----- SECTION-HOME ----- */
    #section-home {
        color: #fff;
        width: 100vw;
    }

    #section-home ul {
        list-style: none;
        align-items: center;
        justify-content: space-between;
    }

    #section-home li a {
        padding: 1rem;
        transition: all 0.3s;
        font-size: 16px;
        color: #fff;
        font-family: "Montserrat";
        font-weight: 300;
        line-height: 1.3;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
    }

    #section-home li:hover a {
        color: #ff7f00;
        text-decoration: underline;
        border-radius: 5px;
    }

    .fixed-bottom {
        right: auto;
        left: 5px;
        bottom: 5px;
    }

    @media screen and (max-width: 767px) {
        #section-login {
            max-width: 50%;
            right: auto;
        }
    }

    @media screen and (max-width: 576px) {
        #section-login {
            max-width: 100%;
            right: 0;
        }
    }

    @media screen and (max-width: 991px) {
        img {
            width: auto;
        }

        @keyframes home {
            from {
                transform: translateX(100vw);
            }

            to {
                transform: translateX(0);
            }
        }
    }

    #cookies {
        border-radius: 5px;
        bottom: 1rem;
        left: 0;
        z-index: 9999;
        -webkit-box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
        -moz-box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
        box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
    }

    .anim-cookies-enter-active {
        animation: cookies 0.6s;
    }

    .anim-cookies-leave-active {
        animation: cookies 0.6s;
        animation-direction: reverse;
    }

    @keyframes cookies {
        from {
            transform: translateY(10vw);
        }

        to {
            transform: translateX(0);
        }
    }

    .fixed-bottom {
        right: auto;
        left: 5px;
        bottom: 5px;
    }

    .router-anim-home-enter-active {
        animation: home 0.6s;
    }

    .router-anim-home-leave-active {
        animation: home 0.6s;
        animation-direction: reverse;
    }
</style>